import { EmailTemplateRecipient } from "../../settings/templates/emailTemplates/emailTemplates.utils";

export type ClientRecipientInput = {
  email?: string | null;
  customerId?: string | null;
  /** Shown on the chip: the client's name (organization or individual). */
  name?: string | null;
  businessContactId?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  contactPersonFirstName?: string | null;
  contactPersonLastName?: string | null;
};

const clean = (value?: string | null) => (value || "").trim() || undefined;

/**
 * The To chip for a client, in the same shape the compose window's client
 * search uses (`mapCustomerToTemplateRecipient`): name + customerId (+
 * businessContactId for organizations) so it shows the "Client" tag and the
 * templates' {{firstName}} etc. fill in. Lists sometimes hold several
 * addresses separated by commas: the first one is used. No address = null.
 */
export const clientRecipient = (
  input: ClientRecipientInput,
): EmailTemplateRecipient | null => {
  const email = clean((input.email || "").split(",")[0]);
  if (!email) return null;
  const name = clean(input.name);
  const isOrganization = !!clean(input.businessContactId);
  const recipient: EmailTemplateRecipient = { email };
  if (name) {
    recipient.name = name;
    recipient.customerName = name;
  }
  const customerId = clean(input.customerId);
  if (customerId) recipient.customerId = customerId;
  if (isOrganization) {
    recipient.businessContactId = clean(input.businessContactId);
    if (name) recipient.companyName = name;
    recipient.contactPersonFirstName =
      clean(input.contactPersonFirstName) || "";
    recipient.contactPersonLastName = clean(input.contactPersonLastName) || "";
  } else {
    const first = clean(input.firstName);
    const last = clean(input.lastName);
    if (first) recipient.firstName = first;
    if (last) recipient.lastName = last;
  }
  return recipient;
};
